import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { useSiteSettings } from '../../context/SiteSettingsContext';
import MembershipIDCard, { printMembershipCard, resolveMedia } from './MembershipIDCard';

export default function MyIDCard() {
  const { settings: siteSettings } = useSiteSettings();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/accounts/profile/')
      .then(res => setProfile(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0B5D1E] mx-auto mt-20"></div>;
  }

  const issued = profile?.qr_assigned && profile?.qr_code;
  const logo = siteSettings?.header_logo;

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">My Membership ID Card</h1>

      {issued ? (
        <div className="flex flex-col items-center gap-6">
          <MembershipIDCard member={profile} logo={logo} />

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => printMembershipCard(profile, logo)}
              className="bg-[#0B5D1E] text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#062E10] transition inline-flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" /></svg>
              Print / Save as PDF
            </button>
            {profile?.qr_code && (
              <a
                href={resolveMedia(profile.qr_code)}
                download={`NIS_QR_${profile?.membership_number || 'member'}.png`}
                className="border-2 border-[#0B5D1E] text-[#0B5D1E] px-6 py-2.5 rounded-lg font-semibold hover:bg-green-50 transition inline-flex items-center justify-center gap-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>
                Download QR
              </a>
            )}
          </div>

          <div className="w-full bg-blue-50 rounded-xl border border-blue-200 p-4">
            <h3 className="font-semibold text-blue-900 mb-2">About Your ID Card</h3>
            <ul className="text-sm text-blue-700 space-y-1">
              <li>• This is your official NIS FCT Branch digital membership card.</li>
              <li>• The QR code links to your verified public member profile.</li>
              <li>• Use “Print / Save as PDF” to keep a printable copy on your phone.</li>
              <li>• Contact the branch admin if any details are incorrect.</li>
            </ul>
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border p-10 text-center">
          <div className="w-20 h-20 mx-auto bg-gray-100 rounded-full flex items-center justify-center mb-5">
            <svg className="w-10 h-10 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 8h4v4H7V8zm0 8h10M15 8h2m-2 4h2" /></svg>
          </div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">Your card hasn’t been issued yet</h2>
          <p className="text-gray-500 max-w-md mx-auto">
            The branch administrator has not yet issued your digital membership ID card.
            Once it is issued, it will appear here for you to view, print and share.
          </p>
        </div>
      )}
    </div>
  );
}
